import {apiClient} from './client';

const baseUrl = "city"

export const searchByIds = (ids:string[]) => {
    if(ids == null || ids.length < 0) {
        return new Promise((resolve) => {resolve([])})
    }

    if(typeof ids  !== "string"){
        ids = ids.join(',')
    }

    return apiClient.get(`${baseUrl}/search/findByIds?ids=${ids}`)
}
